var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIconOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42165 1.89551C9.70573 1.89551 9.96543 2.05601 10.0925 2.3101L12.0267 6.17846L16.2796 6.79707C16.5621 6.83816 16.7967 7.03603 16.8849 7.3075C16.9732 7.57898 16.8996 7.87699 16.6952 8.07626L13.5999 11.0942L14.2962 15.3494C14.3422 15.6306 14.2249 15.9136 13.9934 16.0798C13.7619 16.246 13.4562 16.2666 13.2045 16.133L9.42165 14.1258L5.63881 16.133C5.38709 16.2666 5.08142 16.246 4.84993 16.0798C4.61843 15.9136 4.5011 15.6306 4.54712 15.3494L5.24342 11.0942L2.14808 8.07626C1.9437 7.87699 1.87015 7.57898 1.95836 7.3075C2.04656 7.03603 2.28122 6.83816 2.5637 6.79707L6.81665 6.17846L8.75083 2.3101C8.87788 2.05601 9.13757 1.89551 9.42165 1.89551Z",
    fill: "#4379F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconOn);
export default __webpack_public_path__ + "static/media/starIconOn.cdaff453f6c5ea893124f2238f66ea42.svg";
export { ForwardRef as ReactComponent };